import { APTOS_CONFIG } from 'data/constant';

export type ChainNames = 'Move-Mainnet';

export enum Network {
	'Move-Mainnet' = 'Move-Mainnet',
}

export type NetworkConfig = {
	label: string;
	image: string;
	isTestChain: boolean;
	chainId: number;
	chainName: string;
	path: string;
	name: ChainNames;
	nativeCurrency: {
		name: string;
		symbol: string;
		decimals: number;
	};
	rpcUrls: string[];
	disabled?: boolean;
	comingSoon?: boolean;
};

export const networkConfig: Record<ChainNames, any> = {
	'Move-Mainnet': {
		label: 'Movement Mainnet ',
		image: '/crypto/movement.svg',
		name: 'Move-Mainnet',
		path: 'movement_porto',
		isTestChain: true,
		chainId: APTOS_CONFIG.id,
		chainName: 'testnet',
		nativeCurrency: {
			name: 'MOVE',
			symbol: 'MOVE',
			decimals: 18,
		},
		rpcUrls: [APTOS_CONFIG.rpcUrl],
		blockExplorerUrls: ['https://explorer.devnet.imola.movementlabs.xyz/'],
	},
};
